import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    content: String,
    filename: String,
    type: { type: String, default: "text/plain" }
  }

  download(event) {
    event.preventDefault()

    const blob = new Blob([this.contentValue], { type: this.typeValue })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = this.filenameValue
    a.click()
    window.URL.revokeObjectURL(url)
  }
}
